import {UserInfosFormValues} from '@/redux-store/slices/user-infos';

export const JITSI_MEET_SERVER = 'https://meet.sabidu.net';

export const getJitsiConfig = (
  subject: string,
  isManager: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Record<string, any> => ({
  requireDisplayName: false,
  disableProfile: true,
  disableDeepLinking: true,
  disableAddingBackgroundImages: true,
  disableScreensharingVirtualBackground: true,
  disableChatSmileys: true,
  disableInviteFunctions: true,
  disablePolls: true,
  disableReactions: true,
  hideConferenceSubject: true,
  subject: subject,
  startAudioMuted: isManager ? 0 : 1,
  startVideoMuted: isManager ? 0 : 1,
  toolbarButtons: isManager
    ? [
        'camera',
        'microphone',
        'chat',
        'raisehand',
        'mute-everyone',
        'mute-video-everyone',
        'participants-pane',
        'hangup'
      ]
    : [
        'camera',
        'microphone',
        'chat',
        'raisehand',
        'participants-pane',
        'hangup'
      ],
  'prejoinConfig.enabled': false
});
export const getUserInfo = (user: UserInfosFormValues) => ({
  displayName: user.name,
  email: user.email,
  avatar: user.picture || undefined
});
